import gql from 'graphql-tag'

export const GetInspirationQuery = gql`
  query getProDesignInspiration($seed: Int, $offset: Int, $limit: Int, $tags: [String], $filters: [String]) {
    rows: getProDesignInspiration(seed: $seed, offset: $offset, limit: $limit, tags: $tags, filters: $filters) {
      fullCount
      inspiration {
        id
        name
        image
        width
        height
        tags
        assetType: asset_type
      }
    }
  }
`

export const GetInspirationTags = gql`
  query GetTags {
    rows: getInspirationTags {
      value
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Inspiration/data.ts